import { AppColors } from "@/styles/colors";
import { Checkbox, Table, Text } from "@chakra-ui/react";

interface Props {
  permissions: any[];
  permissionSelection?: number[];
  setPermissionSelection: (value?: number[]) => void;
  disableAll?: boolean;
}

export const PermissionsTable = ({
  permissions,
  permissionSelection,
  disableAll,
  setPermissionSelection,
}: Props) => {
  return (
    <Table.ScrollArea
      css={{
        "@media (max-width: 1350px) and (min-width: 1272px)": {
          height: "240px",
        },
        "@media (max-width: 1414px) and (min-width: 1351px)": {
          height: "300px",
        },
        "@media (max-width: 1590px) and (min-width: 1415px)": {
          height: "380px",
        },
        "@media (max-width: 1696px) and (min-width: 1591px)": {
          height: "435px",
        },
        "@media (max-width: 1900px)": {
          height: "490px",
        },
        "@media (min-width: 1901px)": {
          height: "490px",
        },
      }}
      borderRadius="8px"
    >
      <Table.Root
        css={{
          "@media (max-width: 1350px) and (min-width: 1272px)": {
            height: "240px",
          },
          "@media (max-width: 1414px) and (min-width: 1351px)": {
            height: "300px",
          },
          "@media (max-width: 1590px) and (min-width: 1415px)": {
            height: "380px",
          },
          "@media (max-width: 1696px) and (min-width: 1591px)": {
            height: "435px",
          },
          "@media (max-width: 1900px)": {
            height: "490px",
          },
          "@media (min-width: 1901px)": {
            height: "490px",
          },
        }}
        interactive
        striped
        size="sm"
        borderRadius="8px"
        border={`1px solid ${AppColors.WHITE_BORDER_1}`}
        stickyHeader
      >
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader>
              <Text
                padding="16px"
                color={AppColors.GRAY_TEXT}
                fontWeight={700}
                textTransform="uppercase"
                fontSize="12px"
              >
                Funcionalidad
              </Text>
            </Table.ColumnHeader>
            <Table.ColumnHeader>
              <Text
                padding="16px"
                color={AppColors.GRAY_TEXT}
                fontWeight={700}
                textTransform="uppercase"
                fontSize="12px"
              >
                Seleccione
              </Text>
            </Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {permissions?.map((permission) => (
            <Table.Row key={permission?.id}>
              <Table.Cell>
                <Text
                  padding="16px"
                  fontWeight={400}
                  fontSize="12px"
                  color={AppColors.BLACK_TEXT_SECONDARY}
                >
                  {permission?.descripcion}
                </Text>
              </Table.Cell>
              <Table.Cell>
                <Checkbox.Root
                  disabled={disableAll}
                  top="1"
                  paddingLeft={3}
                  aria-label="Select row"
                  checked={permissionSelection?.includes(permission?.id)}
                  onCheckedChange={(changes) => {
                    let currentSelection = permissionSelection ?? [];
                    setPermissionSelection?.(
                      changes?.checked
                        ? [...currentSelection, permission.id]
                        : permissionSelection?.filter(
                            (id) => id !== permission.id,
                          ),
                    );
                  }}
                >
                  <Checkbox.HiddenInput />
                  <Checkbox.Control borderColor={AppColors.GRAY_BORDER_1} />
                </Checkbox.Root>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Table.ScrollArea>
  );
};
